module.exports = __webpack_public_path__ + "img/bubbles.86fd2de8.png";